require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-choose-a-stack-part-5-java.json") })
        }
      }, "path---blog-how-to-choose-a-stack-part-5-java");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-choose-a-stack-part-5-java!./.cache/json/blog-how-to-choose-a-stack-part-5-java.json
// module id = 870
// module chunks = 231608221292675